var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-wrapper"},[_c('button',{staticClass:"qr-code-wrapper",class:{fullscreen: _vm.fullscreen},on:{"click":_vm.toggleFullscreen}},[_c('canvas',{ref:"canvas",staticClass:"qr-code"})])])}
var staticRenderFns = []

export { render, staticRenderFns }